export function InsigniaActiva({
  activa,
  alAlternar,
  nombre,
  cambiando = false,
}: {
  activa: boolean;
  alAlternar: () => void;

  nombre: string;
  cambiando?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={alAlternar}
      disabled={cambiando}
      aria-pressed={activa}
      aria-label={`${activa ? 'Desactivar' : 'Activar'} ${nombre}`}
      title={activa ? 'Desactivar' : 'Activar'}
      className={`inline-flex shrink-0 items-center gap-1.5 rounded-full px-3 py-1 text-[11px] font-semibold uppercase transition-colors disabled:opacity-50 ${
        activa
          ? 'bg-emerald-50 text-emerald-700 hover:bg-emerald-100'
          : 'bg-armazon-100 text-armazon-500 hover:bg-armazon-200'
      }`}
    >
      <span className="size-1.5 rounded-full bg-current" aria-hidden />
      {activa ? 'Activa' : 'Inactiva'}
    </button>
  );
}
